import { TranslationFunctionType } from '@/common/types';

// Campaign recommendation configuration constants
export const RECOMMENDATION_CONFIG = {
  // Form validation
  MIN_COUNT: 1,
  MAX_COUNT: 24,
  DEFAULT_COUNT: 4,

  // UI
  MODAL_WIDTH: '800px',
  MOBILE_BREAKPOINT: '768px',
} as const;

// Loading messages for the progress indicator
export const THINKING_MESSAGES = [
  'Analyzing your previous campaigns...',
  'Looking for patterns in user engagement...',
  'Identifying top-performing content...',
  'Applying machine learning algorithms...',
  'Considering industry best practices...',
  'Optimizing for your target audience...',
  'Evaluating click-through rates...',
  'Assessing email subject line effectiveness...',
  'Checking seasonal campaign performance...',
  'Generating personalized recommendations...',
] as const;

export const CAMPAIGN_GENERATION_LOADING = (t: TranslationFunctionType) =>
  [
    t('phishing.simulations.modal.aiSimulation.loadingMessages.1'),
    t('phishing.simulations.modal.aiSimulation.loadingMessages.2'),
    t('phishing.simulations.modal.aiSimulation.loadingMessages.3'),
    t('phishing.simulations.modal.aiSimulation.loadingMessages.4'),
    t('phishing.simulations.modal.aiSimulation.loadingMessages.5'),
    t('phishing.simulations.modal.aiSimulation.loadingMessages.6'),
  ] as const;

export const RECOMMENDED_SIMULATION_ID = '5b2059e5-254a-4eb6-b02a-921193575c39';
export const RECOMMENDED_CAMPAIGN_NAME = 'Employee Benefits';
